'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellCircle, iconBellCircleTag } from '@ni/nimble-components/dist/esm/icons/bell-circle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellCircle };
export { iconBellCircleTag };
export const NimbleIconBellCircle = wrap(IconBellCircle);